import {Component, Input} from '@angular/core';
import {QuestionBase} from '../domain/question.base';

@Component({
  selector: 'crds-question-hint',
  template: `
    <div *ngIf="question.hint">
      <ngb-alert [dismissible]="false" type="secondary">
        <i class="material-icons">info</i>
        <span [innerHtml]="question.hint"></span>
      </ngb-alert>
    </div>
  `
})
export class QuestionHintComponent {
  @Input() question: QuestionBase<any>;
}
